<template>
  <div class="org-container">
    <!-- 顶部按钮菜单（和用户管理一模一样） -->
    <div class="menu-tabs">
      <el-button
        v-for="item in menuList"
        :key="item.type"
        :type="activeType === item.type ? 'primary' : 'default'"
        @click="switchType(item.type)"
      >
        {{ item.name }}
      </el-button>
    </div>

    <!-- 子组件：每次切换都会重新渲染，不走缓存 -->
    <EduManage
      v-if="activeType === 'edu'"
      :key="refreshKey"
    />
    <SchoolManage
      v-if="activeType === 'school'"
      :key="refreshKey"
    />
  </div>
</template>

<script>
import EduManage from './EduManage'
import SchoolManage from './SchoolManage'

export default {
  name: 'OrganizationManage',
  components: { EduManage, SchoolManage },
  data() {
    return {
      menuList: [
        { name: '教育局管理', type: 'edu' },
        { name: '学校管理', type: 'school' },
      ],
      activeType: 'edu',
      refreshKey: 0, // 强制刷新组件，彻底清除缓存
    }
  },
  methods: {
    switchType(type) {
      this.activeType = type
      this.refreshKey++ // 切换就刷新，无缓存！
    },
  },
}
</script>

<style scoped>
.org-container {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  height: 100%;
  box-sizing: border-box;
}
.menu-tabs {
  margin-bottom: 20px;
}
.menu-tabs .el-button {
  margin-right: 10px;
}
</style>